// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"e0ba20bb","962":"5d18c97f"}[chunkId] + ".chunk.js";
};